import React from 'react';
import { Input, Button, message, Tabs, Row, Col, InputNumber } from 'antd';
import ExportUtil from '../../common/ExportUtil';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import SitePlanModal from "./SitePlanModal";
import TableC from '../basicElement/TableC';
import Sider from './PlanSider';
import SiteRandomList from "./SiteRandomList";

const { TabPane } = Tabs;
class Site extends React.Component {
    state = {
        loading: false,
        data: [],
        plan: {},
        monthList: [],
        titleList: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 12,
        },
        statisticalType: '',
        activeKey:'Type_Random',
        visitGroupingId: '',
        visitGroupingList: [],
        failterRoteModal:false,
        isShow: false,
        blindInvId: '',
        isGivenSecondLines: false,
    }

    componentDidMount() {
        // const { statisticalType } = this.props.match.params;
        const { activeKey } = this.state;
        this.beforeLoad(activeKey);
        this.queryInvestigationSecondLines();
    }

    // componentWillReceiveProps(nextProps) {
    //     const { statisticalType } = nextProps.match.params;
    //     this.beforeLoad(statisticalType);
    // }

    beforeLoad = (activeKey) => {
        this.setState({
            activeKey,
            sortParams: {},
            searchParams: {},
            pagination: {
                current: 1,
                pageSize: 12,
            },
        }, () => {
            this.queryBlindInvestigation();
        });
        this.queryInvestigationStageByInvId();
        
    }

    queryInvestigationSecondLines = () => {
        //判断是否为执行业务线二级分类为“SSU主导、启动前协助、启动前协助+启动后常规CRC执行、启动后常规CRC执行、非盲”的项目
        const investigationId = sessionStorage.invId || this.props.invId;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationSecondLines,
            data: { invId: investigationId },
            dataType: 'json',
            doneResult: res => {
                const { secondLines, sitePlanFteCal } = res;
                const givenSecondLines = ['SSU主导','启动前协助','启动前协助+启动后常规CRC执行','启动后常规CRC执行','非盲'];
                const isGivenSecondLines = givenSecondLines.includes(secondLines) && sitePlanFteCal;
                this.setState({
                    isGivenSecondLines,
                });
            }
        };
        $.sendRequest(options);
    }


    queryBlindInvestigation = () => {
        const options = {
            method: 'POST',
            url: API_URL.plan.queryBlindInvestigation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { isBlind, secondLines, blindInvId } = res;
                const isShow = isBlind && secondLines === '非盲';
                this.setState({
                    isShow,
                    blindInvId,
                },() => {
                    this.queryVisitGrouping();
                });
            },
        };
        $.sendRequest(options);
    }

    queryVisitGrouping = () => {
        const { blindInvId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.plan.queryVisitGrouping,
            data: {blindInvId},
            dataType: 'json',
            doneResult: res => {
                if ( res && res.data.length <= 0) {
                    return
                }
                this.setState({
                    visitGroupingList: res.data,
                    visitGroupingId:String(res.data[0].visitGroupingId) 
                }, () => {
                    this.loadColumns();
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }
    
    loadColumns = () => {
        const { activeKey,visitGroupingId, blindInvId } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.invDataList,
            data: { statisticalType: activeKey, visitGroupingId, blindInvId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    monthList: res.data.monthlyPlan,
                    plan: res.data.plan || {},
                    oldFilterFailureRate:res.data.plan.filterFailureRate,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { pagination, sortParams, searchParams, activeKey,visitGroupingId, blindInvId } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.siteDataList,
            data: {
                offset: current,
                limit: 10,
                ...sortParams,
                ...searchParams,
                statisticalType:activeKey,
                visitGroupingId,
                blindInvId,
            },
            dataType: 'json',
            doneResult: res => {
                const { data: { sitePlanList: { datas, totalCount }, titleList, judgeInvThree } } = res;
                pagination.total = Math.ceil(totalCount / (10)) * (judgeInvThree ? 13 : 12) ;
                pagination.pageSize = judgeInvThree ? 13 : 12;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                    titleList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { activeKey, searchParams, blindInvId } = this.state;
        ExportUtil.export({ statisticalType:activeKey, ...searchParams, blindInvId }, null, API_URL.export.exportSitesPlan);

    }

    calculateFte = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.plan.sitePlanFteTaskTest,
            data: { invId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    tableRender = index => {
        const { data } = this.state;
    }

    getColumns = () => {
        const { monthList, activeKey, data, titleList } = this.state;
        const { invState } = sessionStorage;
        const shouldFixed = (titleList || []).length > 0;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
            fixed: 'left',
            render: (text, record, index) => {
                const { investigationSiteId } = record;
                return investigationSiteId < 0 ? '-' : text
            }
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            width: 110,
            fixed: 'left',
            render : (text, record, index) => {
                const { investigationSiteId } = record;
                if (investigationSiteId < 0) {
                    return {
                        children: text,
                        props: {
                            colSpan: 0,
                        },
                    };
                }
                return text
            }
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            width: 140,
            fixed: 'left',
            render : (text, record, index) => {
                const { investigationSiteId } = record;
                if (investigationSiteId < 0) {
                    return {
                        children: text,
                        props: {
                            colSpan: 2,
                        },
                    };
                }
                return text
            }
        }, {
            title: '总体计划',
            dataIndex: 'planAmount',
            key: 'planAmount',
            sorter: true,
            fixed: 'left',
            width: 120,
        },{
            title: `实际${activeKey == 'Type_Filter' ? '筛选': activeKey == 'Type_Informed' ? '知情': activeKey == 'Type_Random' ? '随机(入组)':''}数`,
            dataIndex: 'actualAmount',
            key: 'actualAmount',
            fixed: 'left',
            width: 110,
        }, {
            title: '每月计划合计',
            dataIndex: 'monthlyPlanTotalAmount',
            key: 'monthlyPlanTotalAmount',
            width: shouldFixed && 120,
            fixed: 'left',
        }];
        // if ((monthList || []).length !== 0) {
        //     monthList.forEach(item => {
        //         const { year, month } = item;
        //         columns.push({
        //             title: `${year}.${month}`,
        //             dataIndex: `${year}.${month}`,
        //             key: `${year}.${month}`,
        //             width: 80,
        //         });
        //     });
        // } else {
            (titleList || []).forEach(item => {
                const { year, month } = item;
                columns.push({
                    title: `${year}.${month}`,
                    dataIndex: `${year}.${month}`,
                    key: `${year}.${month}`,
                    width: 80,
                    render: (text) => {
                        return text || '0';
                    }
                });
            });
        // }
        
        const { curRole, investigationSiteName } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        const { isShow } = this.state;
        if (showOperator && activeKey == 'Type_Random' && !isShow) {
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: shouldFixed && 'right',
                width: 60,
                render: (text, record, index) => {
                    const { investigationSiteId } = record;
                    if (investigationSiteId > 0) {
                        return (
                            <a onClick={() => this.canEditByInvStatus(() => this.setSitePlan(investigationSiteId))}>{!investigationSiteName ? '设置' : '调整'}</a>
                        );
                    }
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination, visitGroupingList = [], visitGroupingId } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = data.map((item, index) => {
            const { investigationSite, monthlyPlanList, ...rest } = item;
            const params = {
                index: (current - 1) * pageSize + index + 1,
                ...rest,
                ...investigationSite,
            };
            if (monthlyPlanList && Array.isArray(monthlyPlanList)) {
                monthlyPlanList.forEach(monthlyPlan => {
                    const { year, month, planAmount } = monthlyPlan;
                    params[`${year}.${month}`] = planAmount;
                });
            }
            return params;
        });
        let newDataSource = [];
        if (visitGroupingId != (visitGroupingList[0] || {}).visitGroupingId) {
            newDataSource = dataSource.filter(el => el.investigationSiteName !== '待配置中心')
        } else {
            newDataSource = dataSource;
        }
        return newDataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    setSitePlan = siteId => {
        const { activeKey, visitGroupingId } = this.state;
        this.siteRef.show(activeKey, siteId, visitGroupingId);
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    searchComponent = () => {
        const { siteId, curRole } = sessionStorage;
        const { isGivenSecondLines } = this.state;
        if (siteId == 0) {
            const { searchParams: { invSiteCode, invSiteName } } = this.state;
            return (
                <div className="filter-bar">
                    <div className='form-item'>
                        <label className='ui-label'>中心编号</label>
                        <Input
                            value={invSiteCode}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'invSiteCode')}
                        />
                    </div>
                    <div className='form-item'>
                        <label className='ui-label'>中心名称</label>
                        <Input
                            value={invSiteName}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'invSiteName')}
                        />
                    </div>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    {
                        isGivenSecondLines && curRole == 'PM' && <Button type="primary" onClick={this.calculateFte}>计划FTE计算</Button>
                    }
                </div>
            );
        } 
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            data: [],
            activeKey,
        }, () => {
            this.loadData();
        });
    }

     // 筛选失败率
     editFilterFailureRate = ()=>{
        this.setState({
            failterRoteModal:true
        })
    }
    cancelFilterFailureRate = ()=>{
        const { plan, oldFilterFailureRate } = this.state;
        plan.filterFailureRate = oldFilterFailureRate;
        this.setState({
            failterRoteModal:false,
            plan
        })
    }
    saveFilterFailureRate = ()=>{
        const { activeKey, plan } = this.state;
        const { filterFailureRate } = plan || {};
        const options = {
            method: 'POST',
            url: API_URL.plan.modifyFailureRate,
            data: { filterFailureRate, statisticalType : activeKey },
            dataType: 'json',
            doneResult: res => {
                if(res && res.error)
                {
                    message.error('更新失败');
                    return;
                }
                message.success('更新成功');
                this.loadData();
                this.cancelFilterFailureRate();
            },
        };
        $.sendRequest(options);
    }
    onInputFailureRate = value => {
        const { plan } = this.state;
        plan.filterFailureRate = value;
        this.setState({ plan });
    }
    
    handleSubTabsChange = (activeKey) => {
        this.setState({
            data: [],
            visitGroupingId:activeKey,
        }, () => {
            this.loadColumns();
            this.loadData();
        });
    }


    getContent = ()=>{
        const { siteId } = sessionStorage;
        const { loading, pagination, sortParams, plan, activeKey,failterRoteModal, visitGroupingList =[], visitGroupingId, isGivenSecondLines } = this.state;
        const { filterFailureRate } = plan || {};
        const { curRole, investigationSiteName  } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        return (
            <div>
                {this.searchComponent()}
                {
                    activeKey == 'Type_Filter' && 
                    <div style={{marginBottom:6}}>
                        {
                            (!failterRoteModal) ? <div>筛选失败率： 
                                {`${filterFailureRate}%`}&nbsp;&nbsp;
                                {
                                  // 各中心执行计划，不需要修改筛选失败率，为保证功能完整性，考虑扩展，故作此处理
                                  (showOperator && false) && <a onClick={this.editFilterFailureRate}><i className="icon iconfont" style={{ fontSize:12 }}>&#xe6a1;</i>&nbsp;修改</a>
                                }
                            </div>
                            : <div>筛选失败率：
                                <InputNumber value={filterFailureRate} precision={0} onChange={this.onInputFailureRate} />&nbsp;%&nbsp;&nbsp;
                                <a onClick={this.saveFilterFailureRate}>保存</a>&nbsp;&nbsp;
                                <a onClick={this.cancelFilterFailureRate}>取消</a>
                            </div>
                        }
                       
                    </div>
                }
                {
                   (visitGroupingList.length > 1 && activeKey == 'Type_Random') && 
                   <Tabs activeKey={visitGroupingId} onChange={this.handleSubTabsChange} type="card">
                        {visitGroupingList.map(item=>{
                            return(
                                <TabPane tab={item.visitGroupingName} key={String(item.visitGroupingId)}></TabPane>
                            )
                        })}
                    </Tabs>
                }
               
                {
                    isGivenSecondLines && activeKey == 'Type_Random' ?
                    <SiteRandomList
                        loading={loading}
                        data={this.state.data}
                        pagination={pagination}
                        sortParams={sortParams}
                        titleList={this.state.titleList}
                        isShow={this.state.isShow}
                        visitGroupingList={visitGroupingList}
                        visitGroupingId={visitGroupingId}
                        onChange={this.handleTableChange}
                        setSitePlan={this.setSitePlan}
                        canEditByInvStatus={this.canEditByInvStatus}
                    />
                    :
                    <TableC
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        pagination={siteId == 0 ? pagination : false}
                        onChange={this.handleTableChange}
                        rowKey="investigationSiteId"
                    />
                }
            </div>
        )
    }

    render() {
        const { activeKey, isShow } = this.state;
        const { curRole, investigationSiteName, siteId } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        let title = siteId == 0 ? '各' : '';
        title+= '中心执行计划'
        // if ('Type_Filter' == activeKey) {
        //     title += '中心筛选计划';
        // } else if ('Type_Informed' == activeKey) {
        //     title += '中心知情计划';
        // } else if ('Type_Random' == activeKey) {
        //     title += '中心随机(入组)计划';
        // }
        return (
            <div className="content">
                <Sider selectKey={activeKey} />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <Row type="flex" align="bottom">
                            <Col span={10} style={{textAlign:'left',color:'red'}}>
                                {showOperator && <span>请先行填写随机（入组）计划，知情计划和筛选计划自动填充</span>}</Col>
                            <Col span={8}> <h2 className="title">{title}</h2></Col>
                            <Col span={6} style={{textAlign:'right'}}>
                                <Button type="primary" onClick={this.export}>导出</Button>
                            </Col>
                        </Row>
                    </div>
                    <div className='box' style={{border:'none'}}>
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange} type="card" className={showOperator ? 'randomStyle' : ''}>
                            {!isShow && <TabPane tab="知情计划" key="Type_Informed">{this.getContent()}</TabPane>}
                            {!isShow && <TabPane tab="筛选计划" key="Type_Filter">{this.getContent()}</TabPane>}
                            <TabPane tab="随机(入组)计划" key="Type_Random" className='childRandomCardStyle'>{this.getContent()}</TabPane>
                        </Tabs>
                    </div>
                </div>
                <SitePlanModal ref={el => this.siteRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default Site;


// WEBPACK FOOTER //
// ./src/components/plan/Site.js